class HeroBanner extends Carousel {
  constructor() {
    super();
    this.carousel.on('moved', (newIndex) => {
      this.handleVideoPlayback(newIndex);
    });

    this.handleVideoPlayback(this.carousel.index);
  }

  handleVideoPlayback(newIndex) {
    const slides = this.carousel.Components.Elements.list.children;

    Array.from(slides).forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (video) {
        if (index === newIndex) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  }
}

customElements.define("hero-banner", HeroBanner);
